import React from 'react';
import { useIntl } from 'react-intl';

import Box from 'carbon-react/lib/components/box';
import RadioButton, { RadioButtonGroup } from 'carbon-react/lib/components/radio-button';

export interface OrientationPickerProps {
  orientation: 'portrait' | 'landscape';
  onOrientationChange: (value: 'portrait' | 'landscape') => void;
}

export const OrientationPicker = ({ orientation, onOrientationChange }: OrientationPickerProps) => {
  const intl = useIntl();

  const handleOrientationChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onOrientationChange(e.target.value as 'portrait' | 'landscape');
  };

  return (
    <div
      style={{ marginLeft: '8px', borderLeft: '2px solid #CCD6DB', marginBottom: '12px' }}
      onClick={e => e.stopPropagation()}
      onChange={e => e.stopPropagation()}
    >
      <Box ml="16px">
        <RadioButtonGroup
          name="page-orientation"
          legend={intl.formatMessage({
            id: 'reporting.page_orientation',
            defaultMessage: 'Page orientation'
          })}
          onChange={handleOrientationChange}
          value={orientation}
          required
          mb={0}
        >
          <RadioButton
            value="portrait"
            label={intl.formatMessage({
              id: 'reporting.portrait',
              defaultMessage: 'Portrait'
            })}
            checked={orientation === 'portrait'}
          />
          <RadioButton
            value="landscape"
            label={intl.formatMessage({
              id: 'reporting.landscape',
              defaultMessage: 'Landscape'
            })}
            checked={orientation === 'landscape'}
          />
        </RadioButtonGroup>
      </Box>
    </div>
  );
};
